module.exports = __webpack_public_path__ + "static/img/ydh1_quit_confirm.e958e550.png";